import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import * as React from "react";

interface RoundIconLabelsProps extends FontAwesomeIconProps {
  labelText: string;
  colorValue: string;
  borderColor: "border-yellow-300" | "border-green-300" | "border-blue-300";
}

const RoundIconLabels = ({
  icon,
  labelText,
  colorValue,
  borderColor,
}: RoundIconLabelsProps) => {
  return (
    <div className="flex flex-row items-center mt-2">
      <FontAwesomeIcon
        icon={icon}
        size={"1x"}
        className={`mr-2 border-4 p-1 w-4 h-4 rounded-full ${borderColor}`}
        color={colorValue}
      />
      <p className="font-sans font-semibold">{labelText}</p>
    </div>
  );
};

export default RoundIconLabels;
